import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment from 'moment';


@Component({
  selector: 'app-leave',
  templateUrl: './leave.component.html',
  styleUrls: ['./leave.component.css']
})
export class LeaveComponent implements OnInit {

  BranchDetails: any;
  SearchModel = {
     StudentNo: '',
  }
  Submitted = false;
  constructor(private financeService: FinanceService, private studentService: StudentService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }


  Reset() {
     this.SearchModel.StudentNo= '',     
     this.Submitted = false;
  }

  IssueTCModel = {
     Gender: "",
     AdmissionDateClass: "",
     ClassPromotion: "",
     StudentNo: '',
     AttendanceLastDate: "",
     DOB: "",
     Reason: "",
     GeneralConduct: "",
     CoScholasticActivity: "",
     SpecialActivity: "",
     ClassPromoted: "",
     ClassFailed: "",
     IssueDate: "",
     LastName: "",
     MiddleName: "",
     FirstName: "",
     ExamLastTaken: "",
     FeePaid: "",
     Attendance: "",
     Remarks: "",
     CourseName: "",
     CertificateDate: "",
     StudentID: 0,
     TCNo:0,
     StudentTCID: 0,
  }

  FilterStudentAdmissionModel = {
     StudentNo: '',
     ClassID: 0,
     SectionID: 0,
     ParentID: 0,
     RegistrationNumber: '',
     FirstName: '',
     ToDate: '',
     FromDate: '',
     TCNo: 0,
     Print: ""
  };

  Clear() {
     this.FilterStudentAdmissionModel.StudentNo= '';
     this.FilterStudentAdmissionModel.Print= '';
     this.FilterStudentAdmissionModel.ClassID= 0;
     this.FilterStudentAdmissionModel.SectionID= 0;
     this.FilterStudentAdmissionModel.ParentID= 0;
     this.FilterStudentAdmissionModel.RegistrationNumber= '';
     this.FilterStudentAdmissionModel.FirstName= '';
     this.FilterStudentAdmissionModel.FromDate= '';
     this.FilterStudentAdmissionModel.ToDate= '';
     this.FilterStudentAdmissionModel.TCNo= 0;      
  }
  AcademicSessionList: any;
  GetAcademicSession() {

     this.lookupService.GetLookupsList('AcademicSession', '').subscribe((data) => {
        this.AcademicSessionList = data.LookupItems;

     });
  };
  ClassList: any;
  GetClass() {

     this.lookupService.GetLookupsList('Class', '').subscribe((data) => {
        this.ClassList = data.LookupItems;

     });
  };
  LeaveStatusList: any;
  GetLeaveStatus() {

     this.lookupService.GetLookupsList('LeaveStatus', '').subscribe((data) => {
        this.LeaveStatusList = data.LookupItems;

     });
  };
  SectionSearchList: any;
  GetSection() {

     this.FilterStudentAdmissionModel.SectionID = 0;
     var ItemBo = {
        'ItemId': this.FilterStudentAdmissionModel.ClassID
     }
     this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data) => {
        this.SectionSearchList = data.LookupItems;

     });
  };
  MsgExist = '';
  Alert = '';
  LeaveList:any;
  GetStudentLeave() {
    
     this.spinnerService.show();
     this.studentService.GetStudentLeave(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((response) => {
        this.spinnerService.hide();
       
           this.LeaveList = response.LeaveList;
          //  this.IssueTCModel.DOB = response.StudentDetails.DOB != null && response.StudentDetails.DOB != '' ? moment(response.StudentDetails.DOB).format("DD-MMM-YYYY") : '';
          //  this.IssueTCModel.AttendanceLastDate = response.StudentDetails.AttendanceLastDate != null && response.StudentDetails.AttendanceLastDate != '' ? moment(response.StudentDetails.AttendanceLastDate).format("DD-MMM-YYYY") : '';
          //  this.IssueTCModel.CertificateDate = response.StudentDetails.CertificateDate != null && response.StudentDetails.CertificateDate != '' ? moment(response.StudentDetails.CertificateDate).format("DD-MMM-YYYY") : '';
          //  this.IssueTCModel.IssueDate = response.StudentDetails.IssueDate != null && response.StudentDetails.IssueDate != '' ? moment(response.StudentDetails.IssueDate).format("DD-MMM-YYYY") : '';

       


     })

  }
  LeaveModel={
   LeaveStatusID:0,
   Remarks:"" ,
   LeaveID:0
  }
  UpdateLeave(valid) {
     this.Submitted = true;
     if (valid) {
      
           this.Submitted = false;
           
          
           this.studentService.UpdateLeave(JSON.stringify(this.LeaveModel)).subscribe((response) => {
            this.GetStudentLeave();
            
              this.globalHelper.CheckActionStatus(response);
              
           })
        
     }
  }


 
  

  Edit(item){
     this.LeaveModel.LeaveID=item.LeaveID;
     this.LeaveModel.Remarks=item.Remarks;
     this.LeaveModel.LeaveStatusID=item.LeaveStatusID;
  }
 


  ngOnInit() {
     this.GetClass();
     this.GetLeaveStatus();
     this.GetStudentLeave();
  }

}